export const stepConfig = [
  {target: '.HeaderContainer', key: 'libraryOverview'},
  {target: '.UploadContainer', key: 'libraryUpload'},
  {target: '.Search', key: 'librarySearch'},
  {target: '.FiltersContainer', key: 'libraryFilters'},
  {target: '.SortPillContainer', key: 'librarySort'},
  {target: '.LibraryFileOptions', key: 'libraryCardOptions'},
];
